export default __webpack_public_path__ + "static/media/Add-policy.1cb141a8.svg";